<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Admin
        <small>Create Admin</small>
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li class="active">Create Admin</li>
      </ol>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="row">
        <div class="col-xs-12">
          <div class="box">
            <div class="box-body">
              <div class="col-xs-12 col-sm-6 col-sm-offset-3">
                <form role="form" v-on:submit.prevent="createAdmin">
                  <div class="form-group">
                    <label for="password">Email</label>
                    <input type="email" v-model.trim="email" class="form-control" id="email" placeholder="Email">
                  </div>
                  <div v-if="submitting" class="form-loader"><img src="/static/assets/loader/nivi-loader.svg" /></div>
                  <div class="form-group">
                    <p v-if="!submitting" :class="message.style">{{message.text}}</p>
                  </div>
                  <div class="box-footer">
                    <button type="submit" class="btn btn-primary">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.row -->
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
  import { logout, createUser } from '../../../utils/auth'
  import { showMessage } from '../../../utils'
  export default {
    name: 'app-createadmin',
    methods: {
      createAdmin () {
        if (!this.email) {
          showMessage(this, 'error', 'Email is required')
        } else {
          this.submitting = true
          createUser(this.email)
            .then((response) => {
              if (response.status === 201) {
                this.email = ''
                showMessage(this, 'success', response.data.payload.msg)
              } else if (response.status === 401) {
                logout()
              } else {
                showMessage(this, 'error', response.data.payload.msg)
              }
            }).catch(() => {
              this.showMessage(this, 'error', 'An internal server error occurred')
            })
        }
      }
    },
    data () {
      return {
        email: '',
        submitting: false,
        message: {
          style: '',
          text: ''
        }
      }
    }
  }
</script>

<style scoped>
  .value {
    font-weight: bold;
  }
  .box-body {
    min-height: calc(100vh - 171px);
  }
  .form-loader img {
    width: 30px;
    height: 30px;
  }
</style>



// WEBPACK FOOTER //
// CreateAdmin.vue?47022b8e